import { reactive, computed } from 'vue'
import { defineStore } from 'pinia'
import api from "@/services/network-service.js";

export const userStore = defineStore('user', () => {
  const state = reactive({
    token: null,
    profile: null
  })

  const token = computed(() => state?.token);
  const profile = computed(() => state?.profile);

  const isLoggedIn = computed(() => !!state.token);
  const isAdmin = computed(() => state.token && state.profile?.isClientAdmin);

  const login = (credentials) => {
    return new Promise((resolve, reject) => {
      api
        .post("/auth/login", {
          companyId: credentials.companyId, 
          email: credentials.email, 
          token: credentials.accessToken
        })
        .then(({ data }) => {
          state.token = data.token?.accessToken;
          localStorage.setItem('dm-ae-token', state.token || '')
          resolve(data.token?.accessToken);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  const requestToken = (companyId, email) => {
    return new Promise((resolve, reject) => {
      api
        .post("/auth/token", {
          companyId, email
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  const logout = () => {
    return new Promise((resolve) => {
      localStorage.setItem('dm-ae-token', '')
      setProfile(null);
      resolve("ok");
    });
  }

  const load = () => {
    console.log("Loading user info")
    let data = localStorage.getItem('dm-ae-token');
    if (data) {
      state.token = data;
      return state.token;
    }
    return null;
  }

  function convertToCamelCase(obj) {
    const camelCaseObj = {};
  
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const camelCaseKey = toCamelCase(key);
        camelCaseObj[camelCaseKey] = obj[key];
      }
    }
  
    return camelCaseObj;
  }
  
  function toCamelCase(str) {
    return str.replace(/\s(.)/g, function($1) {
      return $1.toUpperCase();
    }).replace(/\s/g, '').replace(/^(.)/, function($1) {
      return $1.toLowerCase();
    });
  }

  const setProfile = (profile) => {
    state.profile = convertToCamelCase(profile);
  }

  return {
    token, profile, isLoggedIn, isAdmin,
    login, logout, load, requestToken,
    setProfile
  }
})